<template>
  <teleport to="body">
    <Modal :modalOpened="bookModal" @close="bookModal = false">
      <div class="relative p-8 flex bg-white">
        <div class="grid grid-cols-2 gap-x-10 w-full">
          <div class="col-span-2 md:col-span-1 flex flex-col justify-between">
            <div>
              <div class="font-bold text-2xl">{{ archive?.title }}</div>
              <div class="mb-2 font-bold text-2xl">
                {{ archive?.year }}
              </div>
              <div class="my-2">
                {{ content.mediaAndArchive }} / {{ content[archive?.type] }}
              </div>

              <div
                class="description mt-8 mb-4"
                v-html="archive?.description"
              ></div>
              <div class="flex items-center">
                <a
                  :href="archive?.pdf"
                  target="_blank"
                  v-if="archive?.pdf"
                  class="ltr:mr-5 rtl:ml-5"
                >
                  <div
                    class="
                      py-4
                      px-10
                      bg-primary
                      text-center
                      mt-5
                      w-max
                      transition-all
                      duration-700
                      hover:bg-secondary
                      cursor-pointer
                    "
                  >
                    {{ content.view }}
                  </div>
                </a>
                <a
                  :href="archive?.link"
                  target="_blank"
                  v-if="archive?.link"
                  class="ltr:mr-5 rtl:ml-5"
                >
                  <div
                    class="
                      py-4
                      px-10
                      bg-primary
                      text-center
                      mt-5
                      w-max
                      transition-all
                      duration-700
                      hover:bg-secondary
                      cursor-pointer
                    "
                  >
                    {{ content.download }}
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="col-span-2 relative md:col-span-1 mt-5 lg:mt-0">
            <div class="lg:h-[500px] h-[300px] w-full relative">
              <div
                class="
                  lg:h-[500px]
                  h-[300px]
                  w-full
                  book-img
                  flex
                  ltr:justify-end
                  rtl:justify-start
                  items-end
                "
                :style="`background-image: url(${archive?.image})`"
              ></div>
            </div>
            <!-- <div class="lg:h-[500px] h-[300px] w-full relative">
              <swiper
                :slides-per-view="1"
                :space-between="0"
                :navigation="navigation"
                :loop="true"
              >
                <swiper-slide
                  v-for="(image, index) in 3"
                  :key="index"
                  class="w-full"
                >
                  <div
                    class="
                      lg:h-[500px]
                      h-[300px]
                      w-full
                      book-img
                      flex
                      ltr:justify-end
                      rtl:justify-start
                      items-end
                    "
                    :style="`background-image: url(/static/images/archive.png)`"
                  ></div>
                </swiper-slide>
              </swiper>
              <div
                class="
                  lg:h-20
                  absolute
                  ltr:left-0
                  rtl:right-0
                  bottom-0
                  z-[2]
                  h-12
                  flex
                  justify-between
                  items-center
                  text-3xl
                  bg-primary
                  w-max
                  transition-all
                  duration-700
                  cursor-pointer
                  lg:min-w-[216px]
                  min-w-[120px]
                "
              >
                <div class="lg:px-8 px-4 lg:py-6 py-2 prev-book-img group">
                  <img
                    src="/static/images/icons/arrow-left.svg"
                    alt="arrow-left "
                    class="
                      lg:w-8
                      w-auto
                      h-6
                      md:ltr:ml-2 md:rtl:mr-2
                      rtl:rotate-180
                      md:group-hover:ml-0
                      transition-all
                      duration-300
                    "
                  />
                </div>
                <div class="lg:px-8 px-4 lg:py-6 py-2 next-book-img group">
                  <img
                    src="/static/images/icons/arrow-right.svg"
                    class="
                      lg:w-8
                      w-auto
                      h-6
                      md:ltr:mr-2 md:rtl:ml-2
                      rtl:rotate-180
                      md:group-hover:mr-0
                      transition-all
                      duration-300
                    "
                    alt="arrow-left "
                  />
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </Modal>
  </teleport>

  <teleport to="body">
    <Modal :modalOpened="videoModal" @close="videoModal = false">
      <div class="bg-black">
        <iframe
          width="100%"
          height="560"
          :src="`https://www.youtube.com/embed/${youtubeVideoId}`"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </Modal>
  </teleport>
  <div class="painting-card flex flex-col" @click="showImg">
    <div
      :style="`background:url(${archive.image})`"
      class="h-[350px] painting-img"
    ></div>
    <div class="w-full h-[1px] bg-line mt-8 mb-4"></div>
    <div class="text-2xl mb-4">
      {{
        this.type == "writings" ? archive?.title : archive?.year.substring(0, 4)
      }}
    </div>
    <div class="text-base">{{ content[archive?.type] }}</div>
  </div>
</template>
<script>
export default {
  props: ["archive"],
  data() {
    return {
      imgs: "", // Img Url , string or Array of string
      visible: false,
      index: 0, // default: 0,
      type: null,
      videoModal: false,
      bookModal: false,
      navigation: {
        nextEl: ".next-book-img",
        prevEl: ".prev-book-img",
      },
    };
  },

  inject: ["content"],
  computed: {
    youtubeVideoId() {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = this.archive?.link.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    },
  },
  methods: {
    showImg() {
      if (this.type == "writings") {
        this.$router.push("/writings/" + this.archive.id);
      } else if (this.type == "videos") {
        this.$router.push(`/videos?videoId=${this.youtubeVideoId}`);
      } else if (this.type == "books") {
        this.bookModal = true;
      }
    },
    getThumbnail(videoId) {
      return `https://img.youtube.com/vi/${videoId}/0.jpg`;
    },
    handleHide() {
      this.visible = false;
    },
  },

  mounted() {
    setTimeout(() => {
      this.type = this.archive?.type;
    }, 2);
  },
};
</script>
